import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import endo from "../../practices_images/Endocrinology.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Endocrinology = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
      <div className="cap-container">
        <h1>Endocrinology</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting long term care through operational clarity</h3>
            <p>
              Endocrinology practices manage chronic conditions that require ongoing monitoring, consistent documentation, and coordinated care over time. Treatment plans are often highly individualized, and operational reliability is essential to both clinical and financial outcomes.
            </p>
            <p>
              We partner with endocrinology practices to help them operate with structure, accuracy, and confidence.
            </p>
  
            <h3>The Care Environment</h3>
            <p>
              Endocrinology care involves frequent follow up, detailed diagnostics, and continuous adjustment of treatment plans. Practices must coordinate across labs, manage evolving payer requirements, and maintain precise documentation to support compliance and reimbursement.
            <p>
            </p>
              Without aligned systems, administrative burden increases and continuity of care can be disrupted.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help endocrinology practices strengthen the operational and financial processes that support sustained patient care.
              </p>
              <p>
                Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, improving financial visibility, and aligning workflows across clinical and administrative teams.
              </p>
              <p>
                Our approach reflects the long term nature of endocrinology care delivery.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Consistency and Stability">
              <p>
                Our goal is to help practices operate with predictability and control.
              </p>
              <p>
                By reducing administrative friction and improving financial clarity, we support stronger compliance, more reliable revenue, and a smoother experience for patients over extended courses of care. This allows clinicians to focus on managing complex conditions while leadership maintains operational oversight.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As demand for endocrinology services continues to grow, strong operational foundations remain essential.
              </p>
              <p>
                We work with practices to build the discipline and structure required to support long term patient relationships and organizational resilience.
              </p>
              <p>
                Let’s begin a conversation about how your practice can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={endo} alt="Endocrinology" />
          </div>

        </div>
      </div>
  </motion.div>
  );
};

export default Endocrinology;
